import { gql } from '@apollo/client';
/**
 * Réservations d'autres soumissions qui bloquent des items, directement ou
 * par un lien « Réserve aussi » (`via`).
 * @const SaleItemAvailabilityQuery
 * @since 1.0.0
 */
export const SaleItemAvailabilityQuery = gql `
  query SaleItemAvailabilityQuery($input: SaleItemAvailabilityInput!) {
    saleItemAvailability(input: $input) {
      key
      exclusive
      available
      saleItem {
        id
        title
      }
      conflicts {
        via
        date
        dateEnd
        startTime
        endTime
        wholeDay
        deal {
          id
          number
          title
          status
        }
        saleItem {
          id
          title
        }
      }
    }
  }
`;
